import PanelTitle from "./PanelTitle";

export default PanelTitle;
